const FileSaver = require('file-saver');

/**
 * Receive Axios handled error from to return string Message
 *
 * @param {Object || Error} err
 * @returns {string}
 */
const getErrorMessage = (err = {}) => {
    let errMsg = '';

    // Server response  falls out of the range of 2xx
    if (err.response && err.response.data && err.response.data.issuePayload) {
        errMsg = getWarningsMessages(err.response.data.issuePayload);
    }

    // Other errors
    else {
        errMsg = err.message || err.toString();
    }

    return errMsg;
};

/**
 * Return error message from 'issuePayload' error/s
 *
 * @param {Error || Error[] || String || String[]} issuePayload
 * @returns {string}
 */
const getWarningsMessages = (issuePayload) => {
    let errMsg = '';

    if (issuePayload instanceof Error) {
        errMsg = issuePayload.message;
    } else if (issuePayload instanceof Array) {
        issuePayload.forEach((issue) => errMsg += `${issue.message || issue.toString()}. `);
    } else {
        errMsg = issuePayload.toString();
    }

    return errMsg;
};

/**
 *
 * @param {Object || Error} res Receiving response or handled error from axios request
 * @param {Function} funcSuccess (Function success || function error) to generate redux state data
 * @param {Function || undefined} funcError to generate redux state data
 * @returns {Object} Redux state data generated by function (funcSuccess || funcError)
 */
const response = (res, funcSuccess, funcError) => {

    // This is error response
    if (!funcError) {
        funcError = funcSuccess;
        let err = res;

        return funcError(getErrorMessage(err));
    }

    // Server response falls in the range of 2xx
    else {

        // Success
        if( res.data && res.data.status === 1) {
            return funcSuccess(res.data.payload);
        }

        // 200 with warnings
        else if (res.data && res.data.issuePayload) {
            return funcError(getWarningsMessages(res.data.issuePayload));
        }

        // 200 without warnings && res.data.status !== 1
        else {
            return funcError(`Status ${res.data.status}. Error desconocido`);
        }
    }
};

const savePdf = async (data, name) => {

    // Create blob with pdf data
    data = new Blob([data], { type: "application/pdf" });

    // Download pdf to client machine
    FileSaver.saveAs(data, name || 'unnamed.pdf');

};

export const saveExcel = async (data, name) => {
    const b64toBlob = async (data) => {
        const url = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`;
        const response = await fetch(url);
        return await response.blob();
    };

    FileSaver.saveAs(await b64toBlob(data), name || 'unnamed.xlsx');

};

export const saveJson = async (data, name) => {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });

    FileSaver.saveAs(blob, name || 'unnamed.json');
};

export default {
    getErrorMessage,
    getWarningsMessages,
    response,
    savePdf,
    saveExcel,
    saveJson
}